import styled from "styled-components";

import { Box, FlexDiv } from "../../Atoms";

export const VideoOverlay = styled(Box)``;
export const Iframe = styled.iframe``;
export const StyledYoutubeIframe = styled(FlexDiv)`
  position: relative;
  padding-bottom: 56.25%;
  width: 100%;
  ${VideoOverlay} {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1000;
  }
  ${Iframe} {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
